// src/router/exploded.router.ts
import type { RouteRecordRaw } from 'vue-router'

export const explodedRoutes: RouteRecordRaw[] = [
  {
    path: 'exploded',
    name: 'exploded',
    component: () => import('@/views/page/exploded/ExplodedData.vue'),
    meta: { title: 'Exploded View' },
  },
  {
    path: 'exploded/:id',
    name: 'exploded-show',
    component: () => import('@/views/page/exploded/ExplodedShow.vue'),
    meta: { title: 'Exploded View - Detail' },
  },
]
